<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Receipt Printing'" style="padding-bottom: 400px">
      <!-- <div class="info">
                <div class="single">
                    <div>
                      <p>Reg No. : <b>{{record.bill_no}}</b></p>
                      <p>Sub Dept. : <b>{{record.sub_department_name}}</b></p>
                      <p>Service Name : <b>{{record.service_name}}</b></p>
                      <p>Dept. : <b>{{record.department_name}}</b></p>
                    </div>
                  </div>
                  <button [disabled]="stateForm.invalid" (click)="onSubmit(e)"  mat-raised-button color="primary">
                    {{ isSaveLoading? "Adding": "Add"}}
                </button>
            </div> -->
      <div>
        <button
          (click)="makeVisible()"
          style="margin-bottom: 30px; margin-left: 30px"
          mat-raised-button
          color="primary"
        >
          Search
        </button>
      </div>
      <div class="data" style="padding-bottom: 400px">
        <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Receipt No</th>
            <th>Nmae</th>
            <th>Bill Amount</th>
            <th>Amount Paid</th>
            <th>
              <!-- <button  mat-raised-button color="basic">
                            Clear All
                          </button> -->
            </th>
          </tr>
          <tr class="td" *ngFor="let item of data" style="cursor: pointer">
            <td>{{ item.receipt_no }}</td>
            <td>{{ item.patient_first_name }}</td>
            <td>{{ item.bill_amount | currency : "&#8358;" }}</td>
            <td>{{ item.amount_paid | currency : "&#8358;" }}</td>
            <td>
              <button
                (click)="addRecord(item)"
                *ngIf="role == 'Administrator' || role == 'Cashier'"
                mat-raised-button
                color="primary"
              >
                Select
              </button>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>
  <div class="search" *ngIf="visible" [@slideInOut]>
    <div class="bix">
      <div>
        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="end"
            (dateChange)="startDateChange($event)"
          />
          <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
          <mat-datepicker #end></mat-datepicker>
        </mat-form-field>
      </div>
      <span>
        <mat-form-field>
          <mat-label>End Date</mat-label>
          <input
            matInput
            [matDatepicker]="start"
            (dateChange)="endDateChange($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="start"
          ></mat-datepicker-toggle>
          <mat-datepicker #start></mat-datepicker>
        </mat-form-field>
      </span>
      <div>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input [(ngModel)]="name" matInput placeholder="" />
        </mat-form-field>
      </div>
      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="search()"
          style="margin-left: 20px; margin-top: 20px"
        >
          Search
        </button>
      </div>
    </div>
  </div>
  <div class="receipt" *ngSwitchCase="'rec'">
    <app-template
      [title]="'Print Receipt'"
      style="z-index: -3; padding-bottom: 500px"
    >
      <div class="inner">
        <button mat-raised-button color="primary" (click)="printResult()">
          Print
        </button>
        <!-- <button
          mat-raised-button
          color="primary"
          class="create"
          (click)="refund()"
        >
          Refund
        </button> -->
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>

        <div *ngIf="recLoad" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <div
          *ngIf="!recLoad"
          class="return"
          id="receipt"
          style="
            margin-left: 50px;
            margin-bottom: 100px;
            margin-top: 70px;
            position: relative;
            z-index: 2;
          "
          [innerHTML]="receipt"
        ></div>
      </div>
    </app-template>
  </div>
  <div class="wizwig" *ngSwitchCase="'wiz'">
    <app-template
      [title]="'Print Result'"
      style="z-index: -3; padding-bottom: 500px"
    >
      <button mat-raised-button color="primary" (click)="print()">print</button>
      <button
        mat-raised-button
        color="primary"
        style="margin-left: 20px"
        (click)="setReceipt()"
      >
        print Receipt
      </button>
      <button (click)="back()" class="create" mat-raised-button color="primary">
        Back
      </button>
      <div class="space"></div>
      <div class="form">
        <div *ngIf="tempLoad" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <div
          *ngIf="!tempLoad"
          class="result"
          id="print-section"
          style="width: 90%; margin: auto; position: relative"
        >
          <div
            class="detail"
            style="
              margin-top: 0px;
              z-index: 2;
              display: flex;
              flex-direction: row;
              justify-content: space-evenly;
              margin-bottom: 70px;
              margin-left: 30px;
            "
          >
            <div class="main" style="z-index: 2; margin-left: 30px">
              <div class="head">
                <b>Patient Name :</b> {{ templates.data.patient_name }}
              </div>
              <div class="name">
                <b>Referred Code :</b> {{ templates.data.referred_code }}
              </div>
              <div class="name">
                <b>Bill No. :</b> {{ templates.data.bill_id }}
              </div>
              <div class="name">
                <b>Result No. :</b> {{ templates.data.result_id }}
              </div>
            </div>
            <div class="main" style="z-index: 2; margin-left: 40px">
              <div class="name">
                <b>Reporting Date:</b> {{ templates.data.reporting_date }}
              </div>
              <div class="name"><b>Sex:</b> {{ templates.data.sex }}</div>
              <!-- <div class="name"><b>Age:</b>   {{templates.data.age}}</div> -->
              <div class="name">
                <b>Reg No:</b> {{ templates.data.reg_code }}
              </div>
            </div>
          </div>

          <div
            class="return"
            style="
              width: 70%;
              margin: auto;
              margin-bottom: 100px;
              position: relative;
              z-index: 2;
            "
            [innerHTML]="Template_Text"
          ></div>

          <div
            class="sign"
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding: 0 160px;
              z-index: 2;
            "
          >
            <div style="z-index: 2">
              <img
                style="margin-left: -150px"
                [src]="templates.data.initator.signature"
                alt=""
              />
              <div>...........................</div>
              <div>{{ templates.data.initator.name }}</div>
              <div>{{ templates.data.initator.designation }}</div>
              <div>Initator</div>
            </div>
            <div style="z-index: 2; margin-left: 150px">
              <img
                style="margin-left: -150px"
                [src]="templates.data.finalizer.signature"
                alt=""
              />
              <div>...........................</div>
              <div>{{ templates.data.finalizer.name }}</div>
              <div>{{ templates.data.finalizer.designation }}</div>
              <div>Finerlizer</div>
            </div>
          </div>
        </div>

        <div style="height: 500px; width: 100%"></div>
      </div>
    </app-template>
  </div>
</div>
